import { combineReducers } from 'redux'
import MedcardVisitsAllReducer from './medcard.visits.all.reducer'
import MedcardVisitsByPatientReducer from './medcard.visits.bypatient.reducer'

const MedcardVisitsReducer = combineReducers({
  all: MedcardVisitsAllReducer,
  bypatient: MedcardVisitsByPatientReducer,
})

export default MedcardVisitsReducer